import { render, staticRenderFns } from "./BuildingType.vue?vue&type=template&id=740f9b3c&scoped=true"
import script from "./BuildingType.vue?vue&type=script&lang=js"
export * from "./BuildingType.vue?vue&type=script&lang=js"
import style0 from "./BuildingType.vue?vue&type=style&index=0&id=740f9b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f9b3c",
  null
  
)

export default component.exports